import CustomFieldDataType from "@mapmycustomers/shared/enum/CustomFieldDataType";
import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import FieldType from "@mapmycustomers/shared/enum/fieldModel/FieldType";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";

import { DealFieldName } from "@app/util/fieldModel/DealFieldModel";
import { isCustomField } from "@app/util/fieldModel/impl/assert";

export const isFieldSupportedByShapeLegend = (field: IField) =>
  (field.hasAnyFeature(
    FieldFeature.NUMERIC,
    FieldFeature.GROUP_FIELD,
    FieldFeature.FUNNEL_FIELD,
    FieldFeature.SOURCE_FIELD,
    FieldFeature.STAGE_FIELD,
    FieldFeature.TERRITORY_FIELD
  ) &&
    !(
      field.hasFeature(FieldFeature.FREQUENCY_INTERVAL) ||
      field.name === DealFieldName.ADJUSTED_AMOUNT
    )) ||
  (isCustomField(field) &&
    (field.isOptionField || field.type === FieldType.DATE) &&
    field.customFieldData.dataType !== CustomFieldDataType.TIME) ||
  field.name === DealFieldName.CLOSING_DATE;

export const isFieldSupportedByColorLegend = (field: IField) =>
  (field.hasAnyFeature(
    FieldFeature.NUMERIC,
    FieldFeature.FUNNEL_FIELD,
    FieldFeature.STAGE_FIELD,
    FieldFeature.SOURCE_FIELD
  ) &&
    !(
      field.hasFeature(FieldFeature.FREQUENCY_INTERVAL) ||
      field.name === DealFieldName.ADJUSTED_AMOUNT
    )) ||
  (isCustomField(field) &&
    (field.isOptionField || field.type === FieldType.DATE) &&
    field.customFieldData.dataType !== CustomFieldDataType.TIME) ||
  field.name === DealFieldName.CLOSING_DATE;
